<template>
    <div :class="modelValue ? 'justify-start' : 'justify-center'" class="flex flex-wrap items-center gap-2">
        <!-- Tags -->
        <button
            v-for="tag in visibleTags"
            :key="tag.id"
            :class="[
                'rounded-full! border border-primary px-4 font-medium focus-visible:outline-none',
                tag.probability >= 0.2 ? 'h-11 bg-[#F9F6CE] leading-11!' : 'h-8.25 bg-[#E1ECFF] text-sm! leading-8.25!',
                isSpecialTag(tag) && 'bg-[#FAE5EA]',
            ]"
            :disabled="!!modelValue"
            class="truncate"
            type="button"
            @click.stop="selectTag(tag)"
        >
            {{ tag.title }}
        </button>

        <!-- Change button -->
        <button
            v-if="modelValue"
            class="h-8.25 rounded-full px-4 text-sm! leading-8.25 font-medium text-primary hover:underline focus-visible:outline-none"
            type="button"
            @click="clearSelection"
        >
            {{ trans('general.action.change') }}
        </button>

        <!-- More button -->
        <button
            v-if="!modelValue && hasMoreTags && !showAll"
            class="h-8.25 rounded-full px-4 text-sm! font-medium text-primary hover:underline focus-visible:outline-none"
            type="button"
            @click="showAll = true"
        >
            {{ trans('general.more') }}
        </button>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { trans } from '@/mixins/i18n.js';

const props = defineProps({
    tags: {
        type: Array,
        required: true,
    },
    modelValue: {
        type: Object,
        default: null,
    },
    maxVisibleTags: {
        type: Number,
        default: 9,
    },
});

const emit = defineEmits(['update:modelValue']);

const showAll = ref(false);

const isSpecialTag = (tag) => {
    return ['UNKNOWN', 'NOT_LISTED'].includes(tag.type);
};

const regularTags = computed(() => {
    return props.tags.filter((tag) => !isSpecialTag(tag));
});

const specialTags = computed(() => {
    return props.tags.filter((tag) => isSpecialTag(tag));
});

const visibleTags = computed(() => {
    if (props.modelValue) {
        return [props.modelValue];
    }

    const regular = showAll.value ? regularTags.value : regularTags.value.slice(0, props.maxVisibleTags);

    return [...regular, ...specialTags.value];
});

const hasMoreTags = computed(() => {
    return regularTags.value.length > props.maxVisibleTags;
});

const selectTag = (tag) => {
    emit('update:modelValue', tag);
};

const clearSelection = () => {
    emit('update:modelValue', null);
};
</script>
